import { PaymentMethodInput } from '@cashier/cashier-model';

import { validateByLimits, validateByScale } from './fieldValidator';

export const handleSelectField = (properties: PaymentMethodInput) => {
  if (properties.params?.options.length === 1) {
    return {
      ...properties,
      isValid: true,
      value: properties.params.options[0].value,
    };
  }
  return {
    ...properties,
    isValid: false,
    value: null,
  };
};

export const handleAmountField = (
  paymentInputs,
  amount,
  min,
  max,
  properties,
) => {
  const isValidByLimits = validateByLimits(amount, Number(min), Number(max));
  const isValidByScale = validateByScale(amount, properties.params);

  return {
    ...paymentInputs.amount,
    value: amount,
    isValid: isValidByLimits && isValidByScale,
  };
};

export const handleDefaultField = (properties: PaymentMethodInput) => ({
  ...properties,
  value: properties.value,
  isValid: false,
});
